<template>
  <CCol col="12" class="d-flex align-items-center justify-content-center">
    <CCol col="12">
      <h2 class="error-code text-center">403</h2>
      <h3 class="text-uppercase text-center">Access Denied/Forbidden !</h3>
      <CCol
        col="12"
        class="d-flex align-items-center justify-content-center box-btn"
      >
        <router-link :to="{ path: `/` }" tag="a">
          <CButton color="info mr-3">{{ $t("label.home_page") }}</CButton>
        </router-link>
      </CCol>
    </CCol>
  </CCol>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: "Error 403",
      titleTemplate: "%s | 株式会社 Fabbi"
    };
  }
};
</script>
<style>
.error-code {
  font-size: 10rem;
  margin-bottom: 1.5rem;
}

.box-btn {
  margin-top: 1.5rem;
}
</style>
